import React, { Component } from 'react'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from 'react-google-maps'
import PropTypes from 'prop-types'

const GOOGLE_MAPS_API_KEY = 'AIzaSyDlEWMTvYHFGCQizJguAmjXAisxMMbUblQ'

const MapComponent = withScriptjs(withGoogleMap((props) => {
  let center = props.center
  console.log('lat, lng:', center)
  return (
    <GoogleMap
      defaultZoom={12}
      center={center}
    >
      {props.isMarkerShown && <Marker position={center} />}
    </GoogleMap>
  )
}))

class Map extends Component {
  render () {
    return (
      <MapComponent
        googleMapURL={'https://maps.googleapis.com/maps/api/js?key=' + GOOGLE_MAPS_API_KEY + '&v=3.exp&libraries=geometry,drawing,places'}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `400px` }} />}
        mapElement={<div style={{ height: `100%` }} />}
        {...this.props}
      />
    )
  }
}

Map.propTypes = {
  center: PropTypes.object,
  isMarkerShown: PropTypes.bool
}

export default Map



// WEBPACK FOOTER //
// ./src/components/Map.js